import React from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter, StaticRouter } from 'react-router-dom';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { pageViewComposer } from '@bibliocommons/analytics-event-composers';
import { useRouter } from '@bibliocommons/utils-routing';
import routes from './routes';

const Router = __SERVER__ ? StaticRouter : BrowserRouter;

export function Routes() {
  const { location } = useRouter();

  React.useEffect(() => {
    // Send page view events on page load and everytime the location changes.
    BCGoogleAnalyticsUtils.pageView(`${location.pathname}${location.search}`);
    sendAnalyticsEvents(pageViewComposer.composePageViewEvent());

    // Update the active header nav everytime the location changes
    if (window.BCHeaderPublic) {
      window.BCHeaderPublic('setActiveNavItem');
    }
  }, [location]);

  return routes;
}

export default function ApplicationRouter(props) {
  return (
    <Router {...props}>
      <Routes />
    </Router>
  );
}

ApplicationRouter.propTypes = {
  location: PropTypes.string
};
